import axios from "axios";
import React, { useEffect, useState } from "react";
import * as Constants from "../../../../constants/urls";
import { useCookies } from "react-cookie";
import Pagination from "react-js-pagination";
import { Link } from "react-router-dom";
import CustomTable from "../../../CustomTable";
const ProductLogs = (props) => {
    const [data, setDate] = useState(undefined);
    const [cookies, setCookie, removeCookie] = useCookies();

    function getLogs(page) {
        const url = Constants.apiUrl + "/api/ag/productLog";
        axios
            .post(
                url,
                { page: page },
                {
                    headers: {
                        Authorization: "Bearer " + cookies.user_server_token,
                    },
                },
            )
            .then((r) => {
                setDate(r.data);
            })
            .catch((e) => {
                if (e.response.status == 403) {
                    window.location = "403";
                }
            });
    }

    const statusTitle = (status) => {
        console.log("STATUS", status);
        let title = "";
        if (status == 0) title = "حذف شده";

        if (status == 1) title = "  مرحله اول انجام شده   ";
        if (status == 2) title = "  مرحله دوم انجام شده   ";
        if (status == 3) title = "  ثبت نهایی شده   ";
        if (status == 4) title = "گم شده";

        return title;
    };
    // useEffect(() => {
    //     getLogs(1);
    // }, []);
    return (
        <React.Fragment>
            <div className="container-fluid">

                <CustomTable
                    apiUrl={"/api/ag/productLog"}
                    columns={[
                        {
                            title: "نام محصول",
                            name: "product"
                        },
                        {
                            title: "عنوان بسته",
                            name: "pack_label"
                        },
                        {
                            title: "بارکد بسته",
                            name: "pack_barcode"
                        },
                        {
                            title: "لوکیشن",
                            name: "location"
                        },
                        {
                            title: "  مقدار قدیم",
                            name: "old_stock"
                        },
                        {
                            title: "مقدار جدید",
                            name: "new_stock"
                        },
                        {
                            title: "زمان",
                            name: "anbargardani"
                        },
                        {
                            title: "اپراتور  ",
                            name: "operator_name"
                        },
                        {
                            title: "وضعیت",
                            name: "status",
                            filters:
                                [
                                    {
                                        value: 1,
                                        title: "مرحله اول انجام شده"
                                    },
                                    {
                                        value: 2,
                                        title: "مرحله دوم انجام شده"
                                    },
                                    {
                                        value: 3,
                                        title: "تکمیل شده"
                                    },
                                    {
                                        value: 4,
                                        title: "گم شده"
                                    },
                                    {
                                        value: 0,
                                        title: "حذف شده"
                                    }

                                ]
                        },     
                          {
                            title: "انبارگردانی",
                            name: "anbargardani"
                        },
                        

                    ]}
                    rows={[
                        "product.prodName_fa",
                        "pack.label",
                        "pack.barcode",
                        "location",
                        "old_stock",
                        "new_stock",
                        "time",
                        "operator.name",
                        "status",
                        "anbargardani.title"

                    ]}

                />


                <div className="mt-4">
                    <Link to={"/admin/anbargardani"}>
                        <button className="btn btn-block btn-danger">
                            خروج
                        </button>
                    </Link>
                </div>
            </div>
        </React.Fragment>
    );
};
export default ProductLogs;
